import React from 'react';

// SDTV: Disable Help, License
import { NavLink } from 'react-router-dom';
import mailgo from 'mailgo';

// material ui
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {getUserRoleFromJWT} from '../helpers';
import {Badge} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

const listItems = [
  { route: '/', text: 'Dashboard' },
  { route: '/devices', text: 'Devices' },
  { route: '/cameras', text: 'Cameras', isBadges: true },
  { route: '/vcam', text: 'Vcams' },
  { route: '/infrastructures', text: 'Infrastructures' },
  //  { route: '/events&metrics', text: 'Events & Metrics' },
  { route: '/releases', text: 'FW Releases' },
  { route: '/deployments', text: 'FW Deployments' },
  { route: '/containers', text: 'AI Repository' },
  { route: '/aideployments', text: 'AI Deployments' },
  { route: '/configurations', text: 'Configurations' },
  // { route: '/preferences', text: 'Preferences' },
  { route: '/about', text: 'About' }
];

const viewerListItems = [
  { route: '/', text: 'Dashboard' },
  { route: '/devices', text: 'Devices' },
  { route: '/cameras', text: 'Cameras' },
  { route: '/vcam', text: 'Vcams' },
  { route: '/infrastructures', text: 'Infrastructures' },
  { route: '/events&metrics', text: 'Events & Metrics' },
  { route: '/deployments', text: 'FW Deployments' },
  { route: '/configurations', text: 'Configurations' },
  { route: '/about', text: 'About' }
];

const sysAdminListItems = [
  { route: '/', text: 'Dashboard' },
  { route: '/system-admin', text: 'Tenants' },
  { route: '/about', text: 'About' }
];

export default class LeftNav extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isHosted: window.location.hostname === 'hosted.mender.io',
      currentUserRole: getUserRoleFromJWT(),
      camerasBadges: 0,
      showCamerasBadges: false
    };
  }

  componentDidMount() {
    mailgo();
  }

  getItems() {
    let items;
    if (getUserRoleFromJWT() === 'viewer')
      items = viewerListItems;
    else if (this.getIsAdminUser())
      items = sysAdminListItems;
    else
      items = listItems;
    return items;
  }

  render() {
    const self = this;
    let linksItems = this.getItems().map((item, index) => {
      return (
        <ListItem
          key={index}
          to={item.route}
          component={NavLink}
          exact={item.route === '/'}
          className="navLink leftNav"
          style={{ padding: '18px 16px 18px 42px' }}
          onClick={() => this.props.updateRedirect({})}
        >
          <Grid container>
            <Grid item xs={8}>
              <ListItemText primary={item.text} style={Object.assign({ textTransform: 'uppercase' })} />
            </Grid>
          </Grid>
        </ListItem>
      );
    });

    return (
      <div>
        <div className={self.props.className} style={{ overflow: 'auto' }}>
          <List style={{ padding: '0' }}>{linksItems}</List>
          <div style={{ padding: '18px 16px 18px 42px',color: 'grey' }}>
            {self.props.version ? `Version: ${self.props.version}` : '0.20.0'}
          </div>
          <div style={{ padding: '18px 16px 18px 42px', marginBottom: 48 }}>
            <a
              href="mailto:support@edgeway.io"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'grey', textDecoration: 'underline' }}
            >
              EdgeWay support
            </a>
          </div>
        </div>
      </div >
    );
  }

  createBadge(className, content = ' ') {
    return (
      <Badge
        color={'error'}
        overlap={'circle'}
        badgeContent={content}
        className={`${className} leftNav-custom-budged-size`}
      />
    );
  }

  getIsAdminUser() {
    return getUserRoleFromJWT() === 'systemadm';
  }
}
